import React, { useMemo } from 'react';
import commons from 'legacyfrontend/components/commons';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';

const BannerSimple = ({ data }) => {
  const { getNavigationProps } = useBannerNavigation();
  const { title, mostrarTitulo } = data;
  const imgUrl = commons.imgUrlSliderValidator(data.imageUrl);
  const filteredTitle = commons.filterText(title).toUpperCase();
  const navigationProps = getNavigationProps(data);

  return (
    <a
      className='block transition duration-500 shadow-sm hover:shadow-lg'
      href={navigationProps.href}
      target={navigationProps.target}
      rel='noreferrer'
    >
      <div className='relative rounded overflow-hidden'>
        <img
          className='bannerSimplaX3_img object-cover bg-white'
          src={imgUrl}
          alt={commons.filterText(title)}
        />
        {title && title !== '' && !mostrarTitulo && (
          <div
            className='
            bannerSimpleX3_img-text
            absolute bottom-0
            w-full py-7 px-4
            '
          >
            {filteredTitle}
          </div>
        )}
      </div>
    </a>
  );
};

export default function BannerSimpleX3({ data }) {
  const { banner } = data;
  const bannerListLength = (banner && banner.length) || 0;

  const renderBanner = useMemo(() => {
    let bannerList = [];

    for (let count = 0; count < bannerListLength && count <= 2; count++) {
      bannerList = bannerList.concat([
        <BannerSimple key={banner[count].title} data={banner[count]} />,
      ]);
    }

    return bannerList;
  }, [banner]);

  return (
    <div className='container'>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-5 mb-10'>{renderBanner}</div>
    </div>
  );
}
